import axios from "axios"

export const get = (customerId) => {
  return axios.get(`/api/customers/get?customerId=${customerId}`).then((response) => {
    return response.data
  })
}

export const getAll = () => {
  return axios.get(`/api/customers/getAll`).then((response) => {
    return response.data
  })
}

export const getTrainingsForCustomer = (customerId) => {
  return axios.get(`/api/customers/getTrainingsForCustomer?customerId=${customerId}`).then((response) => {
    return response.data
  })
}

export const save = (customer) => {
  return axios
    .post(`/api/customers/save`, {
      data: customer
    })
    .then((response) => {
      return response.data
    })
}

export const createAccount = (customerEmail) => {
  return axios.post(`/api/customers/createAccount`, {
    data: customerEmail
  })
}

export const sendMessageToCustomer = (data) => {
  return axios.post(`/api/customers/sendMessageToCustomer`, {
    data
  })
}

export const saveTrainings = (customerTrainings) => {
  return axios.post(`/api/customers/saveTrainings`, {
    data: customerTrainings
  })
}

export const deleteCustomer = (customer) => {
  return axios.post(`/api/customers/delete`, {
    data: customer
  })
}
